import { useFeatureFlags } from '@/Hooks/Company/useFeatureFlags'
import { useAuth } from '@/Hooks/Company/useAuth'
import { usePermissions } from '@/Hooks/Company/usePermissions'

const { isAryeoLiteUser } = useAuth()

export default function useZillowMediaExclusivesNavigation() {
  const { hasFeatureFlag } = useFeatureFlags()
  const { hasPermission } = usePermissions()

  const canManageZillowMediaExclusives = hasPermission('zillow_media_exclusives_manage')

  return {
    overviewTitle: 'Zillow media exclusives',
    overviewRouteName: 'web.company.zillow-media-exclusives.index',
    sections: [
      {
        show: true,
        name: 'Media Exclusives',
        description: '',
        children: [
          {
            show: true,
            comingSoon: !hasFeatureFlag('zillow_photographer_branding'),
            name: 'Photographer Branding and HD Photos',
            description:
              "Boost your brand. High resolution photos and your company's name and logo will be displayed in Zillow's photo viewer.",
            routeIsInertia: true,
            targetRouteName: canManageZillowMediaExclusives
              ? 'web.company.zillow-media-exclusives.zillow-photographer-branding.show'
              : null,
            image:
              'https://aryeo.sfo2.cdn.digitaloceanspaces.com/aryeo_media/files/zillow-media-exclusives/photographer-branding-hd-photos.png',
            imageObjectFit: 'contain',
            routeNamesToCheckIfCurrent: [
              'web.company.zillow-media-exclusives.zillow-photographer-branding.*',
            ],
            integrationProvider: 'ZILLOW_PHOTOGRAPHER_BRANDING',
            shouldShowBadge: true,
            requiresProAccount: false,
          },
          {
            show: true,
            comingSoon: false,
            name: 'Showcase',
            description:
              'Get more business by signing up to capture Showcase media and more for agents who use the Showcase agent experience platform.',
            routeIsInertia: true,
            targetRouteName: canManageZillowMediaExclusives
              ? 'web.company.zillow-media-exclusives.showcase-select.show'
              : null,
            image:
              'https://aryeo.sfo2.cdn.digitaloceanspaces.com/aryeo_media/files/zillow-media-exclusives/showcase-select.png',
            routeNamesToCheckIfCurrent: ['web.company.zillow-media-exclusives.showcase-select.*'],
            integrationProvider: 'SHOWCASE',
            shouldShowBadge: true,
            requiresProAccount: true,
          },
          {
            show: true,
            comingSoon: false,
            name: 'Virtual Staging AI',
            description:
              'Enhance your listing photos for free with AI-powered virtual staging and day to dusk transformations.',
            routeIsInertia: true,
            targetRouteName: canManageZillowMediaExclusives
              ? 'web.company.zillow-media-exclusives.virtual-staging-ai.show'
              : null,
            image:
              'https://aryeo.sfo2.cdn.digitaloceanspaces.com/aryeo_media/vsai_examples/staging-examples/bedroom-modern.webp',
            imageObjectFit: 'contain',
            routeNamesToCheckIfCurrent: [
              'web.company.zillow-media-exclusives.virtual-staging-ai.*',
            ],
            integrationProvider: 'VIRTUAL_STAGING_AI',
            shouldShowBadge: true,
            requiresProAccount: true,
          },
          {
            show: !isAryeoLiteUser.value && hasFeatureFlag('zillow_rentals'),
            comingSoon: false,
            name: 'Zillow Rentals',
            description:
              'Get recommended to Zillow Rental Partners by joining a curated list of media ' +
              'providers who can capture Zillow 3D Home tours and interactive floor plans.',
            routeIsInertia: true,
            targetRouteName: canManageZillowMediaExclusives
              ? 'web.company.zillow-media-exclusives.zillow-rentals.show'
              : null,
            image:
              'https://aryeo.sfo2.cdn.digitaloceanspaces.com/aryeo_media/files/zillow-media-exclusives/zillow-rentals.png',
            imageObjectFit: 'contain',
            routeNamesToCheckIfCurrent: ['web.company.zillow-media-exclusives.zillow-rentals.*'],
            integrationProvider: 'ZILLOW_RENTALS',
            shouldShowBadge: true,
            requiresProAccount: false,
          },
          {
            show: true,
            comingSoon: !hasFeatureFlag('zillow_3d_home'),
            name: 'Zillow 3D Home',
            description:
              'Streamline your workflow and sync tours directly to your listings with the 3D Home Integration.',
            routeIsInertia: true,
            targetRouteName: canManageZillowMediaExclusives
              ? 'web.company.zillow-media-exclusives.zillow-3d-home.show'
              : null,
            image:
              'https://aryeo.sfo2.cdn.digitaloceanspaces.com/aryeo_media/files/zillow-media-exclusives/zillow-3d-home.png',
            routeNamesToCheckIfCurrent: ['web.company.zillow-media-exclusives.zillow-3d-home.*'],
            integrationProvider: 'ZILLOW_3D_HOME',
            shouldShowBadge: true,
            requiresProAccount: false,
          },
          {
            show: true,
            comingSoon: true,
            name: 'More Exclusives',
            description:
              'Your experience is about to get even better! New features and enhancements are coming soon!',
            image:
              'https://aryeo.sfo2.cdn.digitaloceanspaces.com/aryeo_media/files/zillow-media-exclusives/more-media-exclusives.png',
            imageObjectFit: 'contain',
            shouldShowBadge: true,
            requiresProAccount: false,
          },
        ],
      },

      {
        show: true,
        name: 'Settings',
        description: '',
        children: [
          {
            show: true,
            name: 'Zillow Profile',
            description:
              'Create and manage your company profile that will be used across the Zillow media exclusives you have enabled for your company.',
            routeIsInertia: true,
            targetRouteName: canManageZillowMediaExclusives
              ? 'web.company.zillow-media-exclusives.profile.edit'
              : null,
            routeNamesToCheckIfCurrent: ['web.company.zillow-media-exclusives.profile.*'],
            shouldShowBadge: false,
          },
        ],
      },
    ],
  }
}
